module.exports = __webpack_public_path__ + "static/media/Discovery-Brand.998388f3.svg";